import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "form-group mb-3" }
const _hoisted_3 = {
  for: "userName",
  class: "form-label"
}
const _hoisted_4 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_5 = { class: "form-group mb-3" }
const _hoisted_6 = {
  for: "password",
  class: "form-label"
}
const _hoisted_7 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_8 = { class: "form-group mt-4" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTip = _resolveComponent("ToolTip")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isFormInvalid)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "alert alert-danger",
          innerHTML: _ctx.validationMsg
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _createTextVNode("Username "),
        _createVNode(_component_ToolTip, { tooltipText: "Enter your P&A Group MyBenefits username." })
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.userName) = $event)),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideErrors('userName'))),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isSubmitDisabled = false)),
        id: "userName",
        class: _normalizeClass(["form-control", _ctx.v$.user.userName.$error ? 'is-invalid' : 'input-text'])
      }, null, 34), [
        [_vModelText, _ctx.user.userName]
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          class: "small-links float-right",
          to: { name: _ctx.routesPath.forgotUsername }
        }, {
          default: _withCtx(() => [
            _createTextVNode("Forgot username?")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      (_ctx.v$.user.userName.$error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.v$.user.userName.$invalid)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass({ 'is-invalid': _ctx.v$.user.userName.$error })
                }, " Please enter a valid userName ", 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, [
        _createTextVNode("Password "),
        _createVNode(_component_ToolTip, { tooltipText: "Enter your P&A Group MyBenefits password and click continue." })
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.password) = $event)),
        onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideErrors('password'))),
        onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isSubmitDisabled = false)),
        id: "password",
        class: _normalizeClass(["form-control", _ctx.v$.user.password.$error ? 'is-invalid' : 'input-text'])
      }, null, 34), [
        [_vModelText, _ctx.user.password]
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          class: "small-links float-right",
          to: { name: _ctx.routesPath.forgotPassword }
        }, {
          default: _withCtx(() => [
            _createTextVNode("Forgot password?")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      (_ctx.v$.user.password.$error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.v$.user.password.$invalid)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass({ 'is-invalid': _ctx.v$.user.password.$error })
                }, " Please enter a valid password ", 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        disabled: _ctx.v$.user.$invalid || _ctx.isSubmitDisabled,
        class: _normalizeClass(["btn w-100", [_ctx.buttonDesign()]]),
        id: "button-continue",
        type: "submit",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.userLoginPandA()))
      }, " CONTINUE ", 10, _hoisted_9)
    ])
  ], 64))
}